import { forwardRef } from "react"
import { useGetIdentity, useTranslate } from "react-admin"
import GenericMenuItem from "./GenericMenuItem"
import { ManageAccounts } from "@mui/icons-material"

const UserDataMenu = forwardRef((props, ref) => {

  const translate = useTranslate()
  const { data: identity, isLoading } = useGetIdentity()
  if(isLoading || !identity) return null

  return (
    <GenericMenuItem 
      title={translate('resources.users.menu.userData')}
      link={`/users/${identity.id}/show`}
      icon={<ManageAccounts />}
    />
  )
})

export default UserDataMenu